import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './client/header/header.component';
import { SidebarComponent } from './client/sidebar/sidebar.component';
import { MainDashComponent } from './client/main-dash/main-dash.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './client/register/register.component';
import { HttpClientModule } from '@angular/common/http';
import { ApiService } from './shared/api-service/api.service';
import { CustomerService } from './shared/customer/customer.service';
import { AuthService } from './shared/auth/auth.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './shared/interceptors/token.interceptor';
import { AuthGuard } from './shared/guards/auth.guard';
import { InternationalPhoneModule } from 'ng4-intl-phone';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { HelpersService } from './shared/helpers/helpers.service';
import {NgPipesModule} from 'ngx-pipes';
import {NgxPaginationModule} from 'ngx-pagination';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { StaffGuard } from './shared/guards/staff/staff.guard';
import { Ng2FilterPipeModule } from 'ng2-filter-pipe';
import { SearchService } from './shared/search/search.service';
import {Ng2Webstorage} from 'ngx-webstorage';
import { LoginPasswordComponent } from './login-password/login-password.component';
import { LoginVerificationComponent } from './login-verification/login-verification.component';
import { LoginOtpComponent } from './login-otp/login-otp.component';
import { LoginLockedComponent } from './login-locked/login-locked.component';
import { ChangePasswordComponent } from './client/change-password/change-password.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { AccountDashComponent } from './client/account/account-dash/account-dash.component';
import { AccountSidebarComponent } from './client/account/account-sidebar/account-sidebar.component';
import { TotalSubusersPanelComponent } from './client/account/total-subusers-panel/total-subusers-panel.component';
import { SubusersListComponent } from './client/account/subusers-list/subusers-list.component';
import { SubusersCreateComponent } from './client/account/subusers-create/subusers-create.component';
import { PermissionHelper, ComponentID, ActionType } from './shared/helpers/permissionshelper';
import { SubusersComponent } from './client/account/subusers/subusers.component';
import { SubusersEditComponent } from './client/account/subusers-edit/subusers-edit.component';
import { DocumentsComponent } from './client/account/documents/documents.component';
import { BanksComponent } from './client/account/banks/banks.component';
import { WalletsComponent } from './client/account/wallets/wallets.component';
import { ProfileComponent } from './client/account/profile/profile.component';
import { AppsListComponent } from './client/apps/apps-list/apps-list.component';
import { AppsDashComponent } from './client/apps/apps-dash/apps-dash.component';
import { AppsSidebarComponent } from './client/apps/apps-sidebar/apps-sidebar.component';
import { AppsSummaryComponent } from './client/apps/apps-summary/apps-summary.component';
import { AppsEditComponent } from './client/apps/apps-edit/apps-edit.component';
import { TransDetailsComponent } from './client/trans-details/trans-details.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { MainDashchartComponent } from './client/main-dashchart/main-dashchart.component';
import { MainDashrecentListComponent } from './client/main-dashrecent-list/main-dashrecent-list.component';
import { MainDashaccountListComponent } from './client/main-dashaccount-list/main-dashaccount-list.component';
import { CashoutListComponent } from './client/cashout/cashout-list/cashout-list.component';
import { CashouthomeComponent } from './client/cashout/cashouthome/cashouthome.component';
import { CashoutSidebarComponent } from './client/cashout/cashout-sidebar/cashout-sidebar.component';
import { CashoutPendingComponent } from './client/cashout/cashout-pending/cashout-pending.component';
import { CashoutApprovedComponent } from './client/cashout/cashout-approved/cashout-approved.component';
import { CashoutRejectedComponent } from './client/cashout/cashout-rejected/cashout-rejected.component';
import { CashoutAddComponent } from './client/cashout/cashout-add/cashout-add.component';
import { CashoutApproveOtpComponent } from './client/cashout/cashout-approve-otp/cashout-approve-otp.component';
import { CashoutApproveEmailComponent } from './client/cashout/cashout-approve-email/cashout-approve-email.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogService } from './confirm-dialog/ confirm-dialog.service';
import { TransOtherDetailsComponent } from './client/trans-other-details/trans-other-details.component';
import { TimeoutService } from './shared/timeout/timeout.service';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    MainDashComponent,
    LoginComponent,
    RegisterComponent,
    LoginPasswordComponent,
    LoginVerificationComponent,
    LoginOtpComponent,
    LoginLockedComponent,
    ChangePasswordComponent,
    ResetpasswordComponent,
    ProfileComponent,
   AccountDashComponent,
    AccountSidebarComponent,
    TotalSubusersPanelComponent,
    SubusersListComponent,
    SubusersCreateComponent,
    SubusersComponent,
    SubusersEditComponent,
    DocumentsComponent,
    BanksComponent,
    WalletsComponent,
    AppsListComponent,
    AppsDashComponent,
    AppsSidebarComponent,
    AppsSummaryComponent,
    AppsEditComponent,
    TransDetailsComponent,
    MainDashchartComponent,
    MainDashrecentListComponent,
    MainDashaccountListComponent,
    CashoutListComponent,
    CashouthomeComponent,
    CashoutSidebarComponent,
    CashoutPendingComponent,
    CashoutApprovedComponent,
    CashoutRejectedComponent,
    CashoutAddComponent,
    CashoutApproveOtpComponent,
    CashoutApproveEmailComponent,
    ConfirmDialogComponent,
    TransOtherDetailsComponent,
    ToggleSwitchComponent,
    
    
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    InternationalPhoneModule,
    BsDropdownModule.forRoot(),
    NgxIntlTelInputModule,
    NgPipesModule,
    NgxPaginationModule,
    FlashMessagesModule.forRoot(),
    Ng2SearchPipeModule,
    Ng2FilterPipeModule,
    Ng2Webstorage,
    NgxDaterangepickerMd.forRoot({
      separator: ' - ', 
      applyLabel: 'Okay',
      format: 'DD/MM/YYYY',
      cancelLabel: 'Cancel', 
     
    }),
    
    
  ],
  providers: [ApiService, 
              CustomerService, 
              AuthService,{
                provide: HTTP_INTERCEPTORS,
                useClass: TokenInterceptor,
                multi: true,
              },
              AuthGuard,
              HelpersService,
              StaffGuard,
              SearchService,
              PermissionHelper,
              ComponentID,
              ActionType,
              ConfirmDialogService,
              TimeoutService
          ],
          exports: [  
            ConfirmDialogComponent,
            
        ],
  bootstrap: [AppComponent],
  entryComponents: [],
})
export class AppModule {

  constructor(private api: ApiService,
    private auth: AuthService) { }


 }



// WEBPACK FOOTER //
// ./src/app/app.module.ts